import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const GasComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__gas"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_4496_58130)">
        <path
          d="M10 13.3182L10 2.68182C10 2.02912 9.49632 1.5 8.875 1.5L2.125 1.5C1.50368 1.5 1 2.02912 1 2.68182L0.999999 13.3182C0.999999 13.9709 1.50368 14.5 2.125 14.5L8.875 14.5C9.49632 14.5 10 13.9709 10 13.3182Z"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7837 1.45101C12.4805 1.1688 12.0059 1.18581 11.7237 1.48901C11.4415 1.79221 11.4585 2.26678 11.7617 2.54899L12.7837 1.45101ZM14.3626 3.94522L13.8516 4.49421L14.3626 3.94522ZM10 10.7885H11.0192V9.28846H10V10.7885ZM11.75 11.5192V11.75H13.25V11.5192H11.75ZM15.75 11.75V5.4092H14.25V11.75H15.75ZM14.8736 3.39622L12.7837 1.45101L11.7617 2.54899L13.8516 4.49421L14.8736 3.39622ZM15.75 5.4092C15.75 4.64564 15.4325 3.91645 14.8736 3.39622L13.8516 4.49421C14.1057 4.73068 14.25 5.06212 14.25 5.4092H15.75ZM13.75 13.75C14.8546 13.75 15.75 12.8546 15.75 11.75H14.25C14.25 12.0261 14.0261 12.25 13.75 12.25V13.75ZM11.75 11.75C11.75 12.8546 12.6454 13.75 13.75 13.75V12.25C13.4739 12.25 13.25 12.0261 13.25 11.75H11.75ZM11.0192 10.7885C11.4228 10.7885 11.75 11.1156 11.75 11.5192H13.25C13.25 10.2872 12.2513 9.28846 11.0192 9.28846V10.7885Z"
          fill={colorVar}
        />
        <path d="M1 6.5H9.75" stroke={colorVar} strokeWidth="1.5" />
        <path d="M15 6V6C14.4477 6 14 5.55228 14 5V3.5" stroke={colorVar} strokeWidth="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_4496_58130">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Gas = withIcon(GasComponent);
